__turbopack_context__.v({
  "wrapper": "ZYTWdW_wrapper",
  "wrapper--full": "ZYTWdW_wrapper--full",
  "wrapper--gridMaxWidth": "ZYTWdW_wrapper--gridMaxWidth",
  "wrapper--narrow": "ZYTWdW_wrapper--narrow",
});
